<template>
  <div class="w-full flex flex-col border-box">
    <history name='ui--step'
             v-model='currentTopMode'
             @change='onSelectTopMode'
             :empty='initialMode' />
    <portal to='customNavBar'>
      <pbc-tabs class='grow'
                @mode='onSelectTopMode'
                :enable-animate='isAnimationEnabled'
                :current='currentTopMode' />
    </portal>
    <div v-if='currentTopMode !== "placement" && currentTopMode !== "view"' class="flex pb-2 pt-2" style='box-sizing:border-box'>
      <div class="grow mx-2">

        <textarea ref='title'
               :value='title'
               @input='(evt)=> { title=evt.target.value; debouncedChangeTitle() }'
               :class="titleInputClasses"
               placeholder='Enter a title for your post'
               type="text" />

        <p v-if='validationError' class="text-red-500 text-xs italic">Please enter a title.</p>
      </div>

      <pbc-button v-if='currentTopMode !== "placement"' @click='onSave' :disabled='title === ""'>
        <post class="mx-2"/>
        <span class="mr-2">Post</span>
      </pbc-button>

      <!-- to ensure that the cache is populated????? -->
      <apollo-query :query='getPostDraftsQuery'
                    client-id='localClient'
                    class="self-center"
                    >
        <template v-slot="{ result: { loading, error, data }, isLoading, query }">
        </template>
      </apollo-query>

    </div>

    <!--
    <p v-if='validationErrorPostEmpty' class="text-red-500 text-xs italic">Your post is empty. Press the Add button to add a toy.</p>
    -->
    <editor :key='id'
            ref='editor'
            class="grow" :gamedata='editingGamedata'
            :transforms-and-source='transformsAndSource'
            :background-color='backgroundColor'
            :enable-unload-warning='loginState === ""'
            :editing='currentTopMode !== "post"'
            @add-undo='addUndo'
            @editing='onPreviewOrEditing'
            @save-activity='debouncedSaveActivity'
            @post='onSave'
            @animate='onSelectTopMode("animate")'
            @placement='onSelectTopMode("placement")'
            @next='isAnimationEnabled ? onSelectTopMode("animate") : onSelectTopMode("post")'
            @back='onSelectBackFromPosting'
            @remove-draft='onRemoveDraft'
            @first-load='onFirstLoad'
            :title='title'
            />
    <fill-loader v-if='componentLoadingState[0]' />

    <fill-loader v-if='isSavingStash'
                  class="pbc-z-level-3 bg-white opacity-75"
      />

    <pbc-message ref="message" />

    <auth-dialog v-if='promptUserLogin'
                 @close='onCloseAuthDialog'
                 @guest='onGuest'
                  :login-state='loginState'/>


  </div>
</template>
<script>
import { mapState } from 'vuex';
import Post from '@icons/Post.vue';
import PbcTabs from '@ui/molecules/PbcTabs.vue';
import { ApolloQuery } from 'vue-apollo';
import AuthDialog from '@ui/organisms/AuthDialog.vue';
import { deletePostDraft, getPostDraftsQuery, savePostDraftQuery, addItemQuery, savePostStash } from '@/gql/Queries.js';
//import ContentSave from '@icons/ContentSave.vue';
import PbcMessage from '@ui/molecules/PbcMessage.vue';
import gql from 'graphql-tag';
import uuid from 'uuid';
const LONG_PATTERN = "yyyy-MM-dd'T'HH:mm:ss";
import { addMinutes, format, formatISO9075, formatDistanceToNow } from 'date-fns'
import ComponentLazyLoader from '@/lazyloader.js';
import { cloneDeep, debounce, sortBy } from 'lodash';
import Gamedata from '@edit/tree/gamedata.js';
const {componentLoadingState, fn:Editor}  = ComponentLazyLoader(() => import(/* webpackChunkName: "edit" */ '@/edit/organisms/Editor.vue'));

let dummyUserId = uuid.v4();
export default {
  inject: ['api'],
  props: {
    gamedata: {
      type: Object,
      required: true
    },
    parentId: {
      type: String,
      required: true
    },
    opId: {
      type: String,
      required: true
    },
    initialTitle: {
      type: String,
      default: ''
    },
    // this is the draft id
    id: {
      type:String,
      required:true
    },
  },
  methods: {
    onFirstLoad() {
      console.log('on first load');
      if (this.autoPost) {
        this.showPosting = true;
        this.currentTopMode = 'post';
        this.onSave();
      }
    },
    onSelectBackFromPosting() {
      console.log('LOOOOOOL1');
            //@back='showPosting = false; onPreviewOrEditing(); onSelectTopMode("animate")'
      this.showPosting = false;
      this.onPreviewOrEditing();
      if (this.$route.name === 'template' || this.gamedata.game.timelimit === -1 || this.gamedata.template) {
        this.onSelectTopMode("view");
      } else {
        this.onSelectTopMode("animate");
      }
    },
    onSelectTopMode(mode) {
      this.currentTopMode = mode;
      if (mode !== 'post') {
        this.showPosting = false;
        this.$refs.editor.onSelectTopMode(mode);
      } else {
        this.$refs.editor.onSelectTopMode(mode);
        this.showPosting = true;
      }
    },
    onCloseAuthDialog() {
      this.promptUserLogin = false;
      this.$ana.track({
        eventCategory:'engagement',
        eventAction:'closeAuth',
        extra:{type:'post'}
      });

      //this.onSave();
    },
    validate() {
      if (!this.title || this.title === '') {
        this.$refs.title.focus();
        this.validationError = true;
        return false;
      }
      return true;
    },
    async onSave(skipLoggedInCheck = false) {
      if (!this.validate()) {
        this.validationError = true;
        return;
      }
      this.validationError = false;
      this.validationErrorPostEmpty = false;
      const gamedata = this.editingGamedata;
      if (gamedata.scenes[0].transforms.length === 1) {
        this.validationErrorPostEmpty = true;
        this.$refs.message.show({
          title:'Your post is empty. Press the Add button (bottom left) to add a toy.'
        });
        return;
      }
      const data = {
        gamedata:new Gamedata(cloneDeep(gamedata)).clean(),
        title:this.title
      }

      const draft = {
        id:this.id
      }

      if (!skipLoggedInCheck) {
        this.$ana.track({
          eventCategory:'engagement',
          eventAction:'attemptPost',
          extra:{type:'post'}
        });
      }

      if (!skipLoggedInCheck && !this.$store.state.loggedIn) {
      //if (!skipLoggedInCheck) {

        this.isSavingStash = true;
        const {id} = await this.savePostStash();

        await this.saveDraft();

        this.promptUserLogin = true;

        this.loginState = id;

        this.isSavingStash = false;
        return;
      }

      this.$ana.track({
        eventCategory:'engagement',
        eventAction:'madePost',
        extra:{type:'post'}
      });

      this.$emit("save", {data,draft});

      this.$gtag.event('conversion', {'send_to': 'AW-801440214/QHGnCL_UzskBENaDlP4C'});

    },

    async savePostStash() {
      const cleaneddata = new Gamedata(cloneDeep(this.editingGamedata)).clean();

      const updated = format(this.getUTCDate(), LONG_PATTERN);
      const data = await this.$apollo.mutate({
        mutation:savePostStash,
        fetchPolicy:'no-cache',
      });

      const {id,url} = data.data.getSignedPostStashUrl;

      const stashData = {
        type:'draft',
        id:this.id,
        title:this.title,
        created:this.created,
        opId:this.opId,
        parentId:this.parentId,
        data:cleaneddata
      }
      await this.uploadFile(url, JSON.stringify(stashData));

      return {id};

    },
    async saveActivity() {
      const cleaneddata = new Gamedata(cloneDeep(this.editingGamedata)).clean();

      const updated = format(this.getUTCDate(), LONG_PATTERN);
      const data = await this.$apollo.mutate({
        mutation:gql(`
        mutation savePostActivity($id: String!, $deviceid: String!, $updated: String!, $created: String!, $title: String!, $parent: String!, $op: String!, $size: Int!) {
          savePostActivity(id: $id, deviceid: $deviceid, updated: $updated, created: $created, title: $title, parent: $parent, op: $op, size: $size) {
          url
          }
        }
        `),
        fetchPolicy:'no-cache',
        variables:{
          id: this.id,
          deviceid:this.$store.state.fingerprint,
          created: this.created,
          //author: this.userId,
          updated,
          title: this.title,
          parent: this.parentId,
          op: this.opId,
          size: JSON.stringify(cleaneddata).length
        }
      });

      const url = data.data.savePostActivity.url;
      await this.uploadFile(url, JSON.stringify(cleaneddata));

    },
    getUTCDate() {
      const date = new Date();
      return addMinutes(date, date.getTimezoneOffset());
    },
    async addUndo() {
      this.debouncedSaveActivity();
      this.saveDraft();
    },
    onShowDrafts() {
      this.showDrafts = true;
    },
    async onRemoveDraft() {
      console.log('is it this one?!?!?');
      await this.$apollo.mutate({
        mutation:deletePostDraft,
        client:'localClient',
        variables:{
          id: this.id
        }
      });
      console.log('finished is it this one?!?!?');
    },
    async saveDraft() {
      const cleaneddata = new Gamedata(cloneDeep(this.editingGamedata)).clean();
      if (cleaneddata.scenes[0].transforms.length > 1) {
        const updated2 = format(new Date(), LONG_PATTERN)
        const gamedata = JSON.stringify(cleaneddata);
        console.log('save title', this.title);
        await this.$apollo.mutate({
          mutation:savePostDraftQuery,
          //mutation:addItemQuery,
          fetchPolicy:'no-cache',
          client:'localClient',
          variables:{
            id: this.id,
            created: this.created,
            updated: updated2,
            title: this.title,
            gamedata,
            parentId: this.parentId,
            opId: this.opId
          }
        });
      }

    },
    onPreviewOrEditing() {
      this.saveDraft();
    },
    async uploadFile(signedUrl, file) {
      this.loading = true;
      const options = {
        method: 'PUT',
        headers: {
          'Content-Type':'application/json'
        },
        body: file
      };
      const response = await fetch(signedUrl, options)
      if (!response.ok) {
        throw new Error(`${response.status}: ${response.statusText}`);
      }
    },
    useDraft(draftId) {
    },
    onGuest() {
      this.$ana.track({
        eventCategory:'engagement',
        eventAction:'continueAnonymous',
        extra:{type:'post'}
      });

      this.promptUserLogin = false;
      this.onSave(true);
    },
  },
  data() {
    console.log('INITIAL TITLE IS', this.initialTitle);
    let initialMode = 'placement';
    const userId = dummyUserId;
    const editingGamedata = cloneDeep(this.gamedata);
    const gamedata = new Gamedata(editingGamedata);
    gamedata.cleanBuildData();
    const transformsAndSource = gamedata.getSceneByIndex(0);
    const created = format(this.getUTCDate(), LONG_PATTERN);
    const debouncedSaveActivity = debounce(this.saveActivity, 1 * 1000);
    const debouncedChangeTitle = debounce(this.saveDraft, 500);
    const autoPost = this.$route.params.autoPost;
    const showDrafts = false;
    return {
      transformsAndSource,
      debouncedSaveActivity,
      title:this.initialTitle,
      editingGamedata,
      validationError:false,
      validationErrorPostEmpty:false,
      componentLoadingState,
      created,
      userId,
      showDrafts,
      getPostDraftsQuery,
      deletePostDraft,
      debouncedChangeTitle,
      promptUserLogin: false,
      loginState: '',
      ignoreDrafts: false,
      showPosting: false,
      currentTopMode: initialMode,
      isSavingStash: false,
      initialMode,
      autoPost
    }
  },
  async mounted() {
    this.debouncedSaveActivity();

    this.saveDraftInterval = setInterval(this.saveDraft, 20 * 1000);


    this.$ana.track({
      eventCategory:'ui',
      eventAction:'editGamePostOpen'
    });

    if (typeof(this.editingGamedata.__autoRemixTitle) !== 'undefined') {
      console.log('hahaha!??!?!?!?!!!!!!!!!!!!!!!!!', this.editingGamedata.__autoRemixTitle);
      this.title = this.editingGamedata.__autoRemixTitle;
      delete this.editingGamedata.__autoRemixTitle;
      //this.ignoreDrafts = true;
    }

    //await this.saveDraft();

  },
  beforeDestroy() {
    clearInterval(this.saveDraftInterval);
    this.saveActivity();
    this.$ana.track({
      eventCategory:'ui',
      eventAction:'editGamePostClose'
    });
  },
  components: {
    Editor,
    Post,
    PbcMessage,
    //ContentSave,
    ApolloQuery,
    AuthDialog,
    PbcTabs,
  },
  computed:{
    backgroundColor() {
      return this.editingGamedata.game.bgcolor.replace('0x', '#')
    },
    titleInputClasses() {
      const classes = ["pbc-standard-input", "text-xl", "my-1"];
      if (this.validationError) {
        classes.push("border-red-500 border border-2");
      }
      return classes;
    },
    ...mapState(['isAnimationEnabled'])
  },
  watch: {
    currentTopMode(nv) {
      this.$ana.track({
        eventCategory:'topMode',
        eventAction:nv
      });

    },
    title(nv) {
      if (nv.length > 0) {
        this.validationError = false;
      } else {
        this.validationError = false;
      }
    },
    showPosting(nv) {
      if (nv) {
        this.currentTopMode = 'post';
        setTimeout( () => {
          if (this.showPosting) {
            this.validate();
          }
        }, 200);
      }
    }
  }
}
</script>
